import { render } from "./TableEditor.vue?vue&type=template&id=5c475920"
import script from "./TableEditor.vue?vue&type=script&lang=js"
export * from "./TableEditor.vue?vue&type=script&lang=js"

import "./TableEditor.vue?vue&type=style&index=0&id=5c475920&lang=scss"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__